import Signature from '@/api/signature'
import Branch from '@/api/branch'
import { baseState, baseMutations } from '@/store/mixins'
import MainProgram from '@/api/main-program'
import SubProgram from '@/api/sub-program'

export const state = {
  ...baseState,
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        signature_type: attrubutes.signature_type,
        from_branch: attrubutes.from_branch,
        search: context.state.search,
      },
      attrubutes
    )
    return Signature.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return Signature.store(data)
  },

  update(context, data) {
    return Signature.update(data)
  },

  destroy(context, id) {
    return Signature.destroy(id)
  },

  getBranch(context) {
    return Branch.get({
      params: {
        page: -1,
        fields: {
          setup_branch_profiles: 'branch_id,branch_name_en'
        },
        filter: {
          user_branches: true
        }
      }
    })
  },
  getMainProgram(context, attributes = {}) {
    return MainProgram.get({
      params: {
        fields: {
          academic_program_mains: 'acp_id,acp_name_foreign'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getSubProgram(context, attributes = {}) {
    return SubProgram.get({
      params: Object.assign(
        {
          fields: {
            academic_program_subs: 'acps_id,acps_name_foreign'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await Signature.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  update(context, { id, data }) {
    return Signature.update(id, data)
  },
}
